/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react'

import { priceAndParticipants, participantCount, paxSummaryContainer } from '../ServiceCombinedExperienceList.style'

import { formatDate, formatMoney } from '@bonitour/common-functions'
import { Manager, Reference, LightTooltip } from '@bonitour/components'
import { useMemo } from 'react'
import { TRANSPORT_TYPE } from 'constants/activityTypes'

export const ParticipantCount = ({
  timeRange = {},
  feeList = [],
  quantity = 0,
  total = 0,
  dataIndex = 0,
  pickupPlaceName = '',
  isPriceTotalizer = true,
  quantityPerSlot = {},
  experienceType
}) => {
  const isTransport = useMemo(() => experienceType === TRANSPORT_TYPE, [experienceType])

  const { startTime = null, endTime = null } = timeRange

  if (isPriceTotalizer) {
    return (
      <Manager>
        <Reference>
          {(({ ref }) => (
            <div ref={ref} css={priceAndParticipants}>
              <div css={participantCount(dataIndex)}>
                <span>
                  {quantity}
                </span>
              </div>
              <span>{formatMoney(total)}</span>
            </div>
          ))}
        </Reference>
        <LightTooltip className='tooltip' position='top'>
          <ul>
            {Object.entries(quantityPerSlot).map(([slot, qty]) => (
              <li key={`slot-${slot}-${dataIndex}`}>
                {formatDate(slot.split('_')[0])} {slot.split('_')[1]}: <span>{qty}</span>
              </li>
            ))}
          </ul>
        </LightTooltip>
      </Manager>
    )
  }

  return (
    <div css={paxSummaryContainer}>
      <p className='time__label'>
        {startTime} - {endTime}
      </p>
      {pickupPlaceName && (
        <p className='pickup__label'>{pickupPlaceName}</p>
      )}
      {(isTransport && !pickupPlaceName)
        ? (
          <p className='pickup__label'>Nenhum local</p>
        )
        : null}
      {feeList.map(({ name, quantity }) => {
        const safeName = name || '--'
        const safeQuantity = quantity || 0
        return (
          <p key={`fee-${safeName}-${dataIndex}`}>{safeQuantity} x {safeName.toLowerCase()}</p>
        )
      })}
    </div>
  )
}
